<template>
  <div>
    <div class="row">
      <div class="col-md-12 col-lg-12">
        <KTCodePreview v-bind:title="'Grupos Cadastrados'">
          <template v-slot:preview>
            <v-row v-if="processando" class="mb-5">
              <v-col cols="12">
                <v-progress-linear
                  indeterminate
                  color="indigo"
                ></v-progress-linear>
              </v-col>
            </v-row>
            <div col-md-2 col-lg-2>
              <v-btn
                v-if="verificarPermissao(permissoesPadrao.Incluir)"
                color="primary"
                fab
                x-small
                dark
                @click="novoGrupo"
                ><v-icon>mdi-plus</v-icon></v-btn
              >
            </div>
            <br />
            <v-row>
              <v-col cols="6" offset="6">
                <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Pesquisa"
                  single-line
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
            <v-data-table
              :headers="headers"
              :items="grupos"
              :search="search"
              :items-per-page.sync="itemsPerPage"
              :page.sync="page"
            >
              <template v-slot:item="{ item, index }">
                <tr>
                  <td>{{ item.id }}</td>
                  <td>
                    <v-icon v-if="item.icone">{{ item.icone }}</v-icon>
                  </td>
                  <td>{{ item.nome }}</td>
                  <td>{{ item.departamento.caminhoCompleto }}</td>
                  <td>{{ item.template.caminhoCompleto }}</td>
                     <td>
                    <input
                      type="checkbox"
                      :name="'padroEmpresa' + item.id"
                      :id="'padroEmpresa' + item.id"
                      v-model="item.padraoEmpresa"
                      :disabled="true"
                    />
                  </td>
                  <td>
                    <input
                      type="checkbox"
                      :name="'prioridade' + item.id"
                      :id="'prioridade' + item.id"
                      v-model="item.prioridade"
                      :disabled="true"
                    />
                  </td>
                  <td style="min-width: 150px" align="center">
                    <download-excel
                      :ref="'download-relatorio-' + index"
                      class="d-none"
                      :data="configExportar.relatorioExportar"
                      :name="configExportar.nomeArquivo"
                    >
                    </download-excel>
                    <download-excel
                      :ref="'download-relatorio-pendencias-' + index"
                      class="d-none"
                      :data="configExportarPendencias.pendenciasExportar"
                      :name="configExportarPendencias.nomeArquivo"
                    >
                    </download-excel>
                    <v-btn
                      :disabled="!verificarPermissao(2)"
                      color="warning"
                      fab
                      x-small
                      dark
                      @click="editar(item.id)"
                      ><v-icon>mdi-pencil</v-icon></v-btn
                    >
                    <v-btn
                      color="error"
                      :disabled="!verificarPermissao(3)"
                      fab
                      x-small
                      dark
                      @click="inativar(item.id, index)"
                      class="ml-2"
                      ><v-icon>mdi-trash-can</v-icon></v-btn
                    >
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          fab
                          x-small
                          dark
                          @click.stop="downloadRelatorio(item.id, index)"
                          class="ml-2"
                          ><v-icon>mdi-file-export</v-icon></v-btn
                        >
                      </template>
                      <span>Relatório de entidades</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          color="primary"
                          fab
                          x-small
                          dark
                          @click.stop="
                            downloadRelatorioPendencias(item.id, index)
                          "
                          class="ml-2"
                          ><v-icon>mdi-file-excel</v-icon></v-btn
                        >
                      </template>
                      <span>Relatório de pendências</span>
                    </v-tooltip>
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          v-bind="attrs"
                          v-on="on"
                          :disabled="!verificarPermissao(2)"
                          color="success"
                          fab
                          x-small
                          class="ml-2"
                          dark
                          @click="editarNotificacao(item.id)"
                          ><v-icon>mdi-bell-ring</v-icon></v-btn
                        >
                      </template>
                      <span>Editar Notificação</span>
                    </v-tooltip>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </template>
        </KTCodePreview>
      </div>
    </div>
  </div>
</template>

<script>
import KTCodePreview from "@/views/partials/content/CodePreview.vue";
import ApiService from "@/common/services/http/api.service";
import RelatorioService from "@/common/services/http/relatorio.service";
import Swal from "sweetalert2";
import SweetAlert from "@/common/services/sweetalert.service";
import Permissoes from "@/common/services/permissoes/permissoes.js";
import Modulo from "@/common/services/permissoes/modulos.js";
import PermissoesService from "@/common/services/permissoes/permissoes.service.js";
import { SET_LOADING } from "@/store/config.module";

export default {
  name: "grupo",
  data() {
    return {
      processando: false,
      page: 1,
      itemsPerPage: 1,
      permissoesPadrao: {},
      grupos: [],
      search: "",
      headers: [
        { text: "ID", value: "id" },
        { text: "", value: "" },
        { text: "Nome", value: "nome" },
        { text: "Departamento", value: "departamento.caminhoCompleto" },
        { text: "Template", value: "template.nome" },
        { text: "Padrão Empresa", value: "padraoEmpresa" },
        { text: "Prioridade", value: "prioridade" },
        { text: "", value: "" },
      ],
      cliente: {},
      configExportar: {
        relatorioExportar: [],
        nomeArquivo: "",
      },
      configExportarPendencias: {
        pendenciasExportar: [],
        nomeArquivo: "",
      },
      dadosRelatorio: [],
    };
  },
  components: {
    KTCodePreview,
  },
  methods: {
    async downloadRelatorio(grupoID, index) {
      let config = await RelatorioService.relatorioEntidades(
        { grupoID },
        "Grupo"
      );

      if (config) {
        this.configExportar = config;
        setTimeout(() => {
          this.$refs["download-relatorio-" + index].$el.click();
        }, 1000);
      }
    },
    async downloadRelatorioPendencias(grupoID, index) {
      let config = await RelatorioService.relatorioPendencias({ grupoID });

      if (config) {
        this.configExportarPendencias = config;
        setTimeout(() => {
          this.$refs["download-relatorio-pendencias-" + index].$el.click();
        }, 1000);
      }
    },
    popularPaginacaoEntidade() {
      const tabelaGrupo = {
        page: this.page,
        itemsPerPage: this.itemsPerPage,
      };

      sessionStorage.setItem("tabelaGrupo", JSON.stringify(tabelaGrupo));
    },

    novoGrupo() {
      this.popularPaginacaoEntidade();
      this.$router.push({ name: "grupoCadastro" });
    },

    async listaGrupos() {
      const { data: result } = await ApiService.get(
        "grupo/getbyclienteid/" + this.cliente.id
      );

      this.page = 1;
      this.itemsPerPage = 10;

      if (result.success) {
        const tabelaGrupo = sessionStorage.getItem("tabelaGrupo")
          ? JSON.parse(sessionStorage.getItem("tabelaGrupo"))
          : null;

        if (tabelaGrupo) {
          this.itemsPerPage = tabelaGrupo.itemsPerPage;
          this.page = tabelaGrupo.page;
        }

        sessionStorage.removeItem("tabelaGrupo");
        this.grupos = result.data;
      } else SweetAlert.sweetAlertError(result.errors);

      this.$store.commit(SET_LOADING, false);
    },
    editarNotificacao(id) {
      this.$router.push({ path: "notificacao/" + id });
    },
    editar(id) {
      this.popularPaginacaoEntidade();
      this.$router.push({ path: "grupo/cadastro/" + id });
    },

    inativar(id, index) {
      let self = this;

      Swal.fire({
        title: "Tem certeza que deseja excluir esse registro?",
        text: "Essa operação não poderá ser desfeita!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Sim, pode excluir!",
      }).then(function (result) {
        if (result.value) {
          return new Promise((resolve) => {
            ApiService.put("grupo/" + id + "/inativar").then(({ data }) => {
              resolve(data);

              if (data.success === true) {
                Swal.fire({
                  position: "center",
                  icon: "success",
                  title: "Grupo Inativado com Sucesso!",
                  showConfirmButton: false,
                  timer: 1500,
                }).then(function () {
                  self.grupos.splice(index, 1);
                });
              } else SweetAlert.sweetAlertError(data.errors);
            });
          });
        }
      });
    },

    verificarPermissao(permissao) {
      return PermissoesService.verificarAcesso(Modulo.Grupo, permissao);
    },
  },
  mounted() {
    this.$store.dispatch(SET_LOADING, true);
    this.cliente = JSON.parse(window.localStorage.getItem("cliente"));
    this.listaGrupos();
    this.permissoesPadrao = Permissoes;
  },
  created() {
    if (
      !PermissoesService.verificarAcesso(Modulo.Grupo, Permissoes.Visualizar)
    ) {
      SweetAlert.sweetAlertError([
        "Você não tem permissão para acessar essa parte do sistema",
      ]);
      this.$router.push({ name: "index" });
    }
  },
};
</script>
